import React, {Component} from 'react';
import UpcomingAppointment from './components/UpcomingAppointment';
import MyAppointment from './components/MyAppointment';
import PopupCancel from './components/PopupCancel';
import PopupBeforeCancel from './components/PopupBeforeCancel';
import EditAccount from './components/EditAccount';
import PopupSuccessfullyUpdate from './components/PopupSuccessfullyUpdate';
import axios from 'axios';
import {browserHistory} from 'react-router';
import { BASE_URL } from './constants/api';

class MyAccount extends Component {
    constructor(props) {
        super(props);
        this.handleAppointment = this.handleAppointment.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
        this.hidePopupBeforeCancel = this.hidePopupBeforeCancel.bind(this);
        this.showPopupBeforeCancel = this.showPopupBeforeCancel.bind(this);
        this.handleEditAccount = this.handleEditAccount.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleClickEditAccount = this.handleClickEditAccount.bind(this);
        this.handleSuccessfullyUpdate = this.handleClickEditAccount.bind(this);
        this.handleBtnBack = this.handleBtnBack.bind(this);
        this.handlePromoCode = this.handlePromoCode.bind(this);

        this.state = {
            pastAppointments: {},
            appointments: {},
            appointment: {},
            user: {},
            userData: {},
            validField: {},
            activeAppointments: false,
            activeMyAppointment: false,
            activePopupCancel: false,
            activePopupBeforeCancel: false,
            activeEditAccount: true,
            activeSuccessfullyUpdate: false,
            cities: [],
            indexedCities: {}
        }
    }

    handlePromoCode() {
        if ('promoCode' in this.state.userData && this.state.userData['promoCode'].length > 0) {
            let config = {
                headers: {'Access-Token': JSON.parse(localStorage.getItem('user'))['token']}
            };
            let self = this;
            axios.put(`${BASE_URL}/api/v1/user/validate_coupon`, {code: this.state.userData['promoCode']}, config
            ).then(function (response) {
                let data = {
                    token: response.headers['access-token'],
                    user_data: response.data
                };
                localStorage.removeItem("user");
                localStorage.setItem('user', JSON.stringify(data));
                self.setState({
                    user: data,
                    activeSuccessfullyUpdate: false,
                    activeEditAccount: true,
                    validField: {'promo_code': ''}
                })
            }).catch((error) => {
                if (error.response.data.type == "Unauthorized") {
                    localStorage.removeItem("servicesData");
                    localStorage.removeItem("appointment_details");
                    localStorage.removeItem("appointment");
                    localStorage.removeItem("services");
                    localStorage.removeItem("user");
                    alert(error.response.data.type);
                    browserHistory.push(`/StepOne`)
                } else {
                   this.setState({validField: {'promo_code': 'invalid'}})
                }
            });
        }
    }

    handleBtnBack(component_name) {
        switch (component_name) {
            case 'editAccount':
                this.setState({activeAppointments: true, activeEditAccount: false});
                break;
            case 'myAppointment':
                this.setState({activeMyAppointment: false, activeAppointments: true});
                break
        }


    }

    validationCardName(cardname) {
        this.setState({validField: {'cardname': ''}});
        if (!cardname) {
            return 'empty';
        } else if (cardname.split(' ').length != 2) {
            return 'invalid'
        } else {
            return ''
        }
    }

    validationCardNumber(cardno) {
        this.setState({validField: {'cardno': ''}});
        if (!cardno) {
            return 'empty';
        } else if (cardno.length != 16 || !+cardno) {
            return 'invalid'
        } else {
            return ''
        }
    }

    validationSecurityNumber(secno) {
        this.setState({validField: {'secno': ''}});
        if (!secno) {
            return 'empty';
        } else {
            return ''
        }
    }

    validationCardMonth(cardmonth) {
        this.setState({validField: {'cardmonth': ''}});
        if (!cardmonth) {
            return 'empty';
        } else {
            return ''
        }
    }

    validationCardYear(cardyear) {
        this.setState({validField: {'cardyear': ''}});
        if (!cardyear) {
            return 'empty';
        } else {
            return ''
        }
    }

    validFirstName(first_name) {
        this.setState({validField: {'first_name': ''}});
        if (!first_name) {
            return 'empty'
        } else if (first_name.trim().length > 30) {
            return 'many'
        } else {
            return ''
        }
    }

    validLastName(last_name) {
        this.setState({validField: {'last_name': ''}});
        if (!last_name) {
            return 'empty'
        } else if (last_name.trim().length > 30) {
            return 'many'
        } else {
            return ''
        }
    }

    validCity(city) {
        this.setState({validField: {'city': ''}});
        if (!city) {
            return 'empty';
        } else {
            return ''
        }
    }

    validateByCity(postal_code) {
        const { indexedCities, user, userData } = this.state;
        let city = userData.city ? userData.city : user.user_data.city;
        const lower = postal_code.toLowerCase();

        return !!indexedCities[city]
            .zip_codes
            .find(code => lower.startsWith(code.toLowerCase()));
    }

    validPostalCode(postal_code) {
        this.setState({validField: {'zip': ''}});
        const { indexedCities, user, userData } = this.state;
        let city = userData.city ? userData.city : user.user_data.city;

        if (!postal_code) {
            return 'empty';
        } else if (!indexedCities[city].zip_codes) {
            return 'choose_city';
        } else if (postal_code.length !== 6 || !/([a-z]\d){3}/i.test(postal_code)) {
            return 'invalid_format';
        } else if (!this.validateByCity(postal_code)) {
            return 'invalid';
        } else {
            return '';
        }
    }

    validFirstAddr(firstaddr) {
        this.setState({validField: {'firstaddr': ''}});
        if (!firstaddr) {
            return 'empty';
        } else if (firstaddr.length > 50) {
            return 'long';
        } else {
            return ''
        }
    }

    validPhoneNumber(mobile) {
        this.setState({validField: {'mobile': ''}});
        let phone = mobile.replace(/[^0-9]/g, '');
        if (phone.length != 11) {
            return 'invalid';
        } else{
            return ''
        }
    }

    checkConfirmPassword(password, confirmPassword) {
        this.setState({validField: {'confirmPassword': ''}});
        if (!confirmPassword) {
            return 'empty'
        } else if (password != confirmPassword) {
            return 'not_match'
        } else {
            return ''
        }
    }

    validNewPassword(newPassword) {
        this.setState({validField: {'newPassword': ''}});
        if (!newPassword) {
            return 'empty'
        } else {
            return ''
        }
    }

    validOldPassword(oldPassword) {
        this.setState({validField: {'oldPassword': ''}});
        if (!oldPassword) {
            return 'empty'
        } else {
            return ''
        }
    }

    isValidEditAccount(userData) {
        let valid = true;
        let data = {};
        if ('first_name' in userData) data['first_name'] = this.validFirstName(userData.first_name);
        if ('last_name' in userData) data['last_name'] = this.validLastName(userData.last_name);
        if ('cardname' in userData) data['cardname'] = this.validationCardName(userData.cardname);
        if ('cardno' in userData) data['cardno'] = this.validationCardNumber(userData.cardno);
        if ('cardno' in this.state.userData) data['secno'] = this.validationSecurityNumber(userData.secno);
        if ('cardmonth' in userData) data['cardmonth'] = this.validationCardMonth(userData.cardmonth);
        if ('cardyear' in userData) data['cardyear'] = this.validationCardYear(userData.cardyear);
        if ('zip' in userData) data['zip'] = this.validPostalCode(userData.zip);
        if ('firstaddr' in userData) data['firstaddr'] = this.validFirstAddr(userData.firstaddr);
        if ('city' in userData) data['city'] = this.validCity(userData.city);
        if ('mobile' in userData) data['mobile'] = this.validPhoneNumber(userData.mobile);

        if ('confirmPassword' in userData || 'newPassword' in userData) data['oldPassword'] = this.validOldPassword(userData.oldPassword);
        if ('confirmPassword' in userData || 'oldPassword' in userData) data['newPassword'] = this.validNewPassword(userData.newPassword);
        if ('oldPassword' in userData || 'newPassword' in userData) data['confirmPassword'] = this.checkConfirmPassword(userData.newPassword, userData.confirmPassword);
        if (!userData.oldPassword && !userData.newPassword && !userData.newPassword) {
            delete data['confirmPassword'];
            delete data['oldPassword'];
            delete data['newPassword'];
        }


        this.setState({validField: data});

        for (let k in data) {
            if (data[k] != "") {
                this.setState({validField: Object.assign({}, this.state.validField, data)});
                valid = false;
            }
        }
        return valid
    }


    handleClickEditAccount(id) {
        if (this.isValidEditAccount(this.state.userData)) {
            let newDataUser = this.buildObjUser();
            let newCard = this.buildObjCard();
            let newPassword = this.buildObjPassword();

            let config = {
                headers: {'Access-Token': JSON.parse(localStorage.getItem('user'))['token']}
            };


            if (Object.getOwnPropertyNames(newCard).length > 0) {
                axios.put(`${BASE_URL}/api/v1/user/billing_profile`, {credit_card: newCard}, config
                ).then(function (response) {
                    let data = {
                        token: response.headers['access-token'],
                        user_data: response.data
                    };
                    localStorage.removeItem("user");
                    localStorage.setItem('user', JSON.stringify(data))
                }).catch(function (error) {
                    if (error.response.data.type == "Unauthorized") {
                        localStorage.removeItem("servicesData");
                        localStorage.removeItem("appointment_details");
                        localStorage.removeItem("appointment");
                        localStorage.removeItem("services");
                        localStorage.removeItem("user");
                        alert(error.response.data.type);
                        browserHistory.push(`/StepOne`)
                    } else {
                        alert(error.response.data.message);
                    }
                });
            }

            if (Object.getOwnPropertyNames(newDataUser).length > 0) {
                axios.put(`${BASE_URL}/api/v1/user`, {user: newDataUser}, config
                ).then(function (response) {
                    let data = {
                        token: response.headers['access-token'],
                        user_data: response.data
                    };
                    localStorage.removeItem("user");
                    localStorage.setItem('user', JSON.stringify(data))
                }).catch(function (error) {
                    if (error.response.data.type == "Unauthorized") {
                        localStorage.removeItem("servicesData");
                        localStorage.removeItem("appointment_details");
                        localStorage.removeItem("appointment");
                        localStorage.removeItem("services");
                        localStorage.removeItem("user");
                        alert(error.response.data.type);
                        browserHistory.push(`/StepOne`)
                    } else {
                        alert(error.response.data.message);
                    }
                });
            }

            if (Object.getOwnPropertyNames(newPassword).length > 0) {
                axios.put(`${BASE_URL}/api/v1/user/update_password`, {user: newPassword}, config
                ).then(function () {
                }).catch(function (error) {
                    if (error.response.data.type == "Unauthorized") {
                        alert(error.response.data.type);
                        browserHistory.push(`/StepOne`)
                    } else {
                        if (error.response.data.type == "Unauthorized") {
                            localStorage.removeItem("servicesData");
                            localStorage.removeItem("appointment_details");
                            localStorage.removeItem("appointment");
                            localStorage.removeItem("services");
                            localStorage.removeItem("user");
                            alert(error.response.data.type);
                            browserHistory.push(`/StepOne`)
                        } else {
                            alert(error.response.data.message);
                        }
                    }
                });
            }
            this.setState({activeEditAccount: false, activeSuccessfullyUpdate: true})
        }
    }

    buildObjPassword() {
        let user = {};
        if ('newPassword' in this.state.userData) {
            user['old_password'] = this.state.userData.oldPassword;
            user['password'] = this.state.userData.newPassword;
            user['password_confirmation'] = this.state.userData.confirmPassword;
        }
        return user;
    }

    buildObjCard() {
        let credit_card = {};
        if ('cardmonth' in this.state.userData || 'cardname' in this.state.userData || 'cardno' in this.state.userData || 'cardyear' in this.state.userData) {
            credit_card['expiry_month'] = this.state.userData.cardmonth ? this.state.userData.cardmonth : this.state.user.user_data.billing_profile.credit_card.expiry_month;
            credit_card['first_name'] = this.state.userData.cardname ? this.state.userData.cardname.split(' ')[0] : this.state.user.user_data.billing_profile.credit_card.first_name;
            credit_card['last_name'] = this.state.userData.cardname ? this.state.userData.cardname.split(' ')[1] : this.state.user.user_data.billing_profile.credit_card.last_name;
            if (this.state.userData.cardno) credit_card['number'] = this.state.userData.cardno;
            credit_card['expiry_year'] = this.state.userData.cardyear ? this.state.userData.cardyear : this.state.user.user_data.billing_profile.credit_card.expiry_year;
            if (this.state.userData.secno) credit_card['cvv'] = this.state.userData.secno;
            credit_card['postal_code'] = this.state.userData.zip ? this.state.userData.zip : this.state.user.user_data.postal_code;
        }

        return credit_card;
    }

    buildObjUser() {
        let user = {};
        if (this.state.userData.first_name) user['first_name'] = this.state.userData.first_name;
        if (this.state.userData.last_name) user['last_name'] = this.state.userData.last_name;
        if (this.state.userData.firstaddr) user['address'] = this.state.userData.firstaddr;
        if (this.state.userData.city) user['city'] = this.state.userData.city;
        if (this.state.userData.mobile) user['phone_number'] = this.state.userData.mobile;
        if (this.state.userData.zip) user['postal_code'] = this.state.userData.zip;

        return user;
    }

    handleInputChange(propName, value) {
        let data = {};
        data[propName] = value;
        this.setState({userData: Object.assign({}, this.state.userData, data)});
    }

    handleEditAccount() {
        this.state.activeEditAccount ? this.setState({
            activeEditAccount: false,
            activeAppointments: true
        }) : this.setState({
            activeEditAccount: true,
            activeAppointments: false
        })
    }

    handleAppointment(id) {
        let config = {
            headers: {'access-token': JSON.parse(localStorage.getItem('user'))['token']}
        };
        axios.get(`${BASE_URL}/api/v1/appointments/${id}`, config)
            .then((response) => {
                this.setState({appointment: response.data, activeAppointments: false, activeMyAppointment: true});
            })
            .catch((error) => {
                if (error.response.data.type == "Unauthorized") {
                    alert(error.response.data.type);
                    browserHistory.push(`/StepOne`)
                } else {
                    if (error.response.data.type == "Unauthorized") {
                        localStorage.removeItem("servicesData");
                        localStorage.removeItem("appointment_details");
                        localStorage.removeItem("appointment");
                        localStorage.removeItem("services");
                        localStorage.removeItem("user");
                        alert(error.response.data.type);
                        browserHistory.push(`/StepOne`)
                    } else {
                        alert(error.response.data.message);
                    }
                }
            });
    }

    componentWillMount() {
        let user = localStorage.getItem('user');
        if (!user) {
            browserHistory.push(`/StepOne`)
        } else {
            this.setState({user: JSON.parse(user)});
            let config = {
                headers: {'Access-Token': JSON.parse(localStorage.getItem('user'))['token']}
            };
            axios.get(`${BASE_URL}/api/v1/appointments?filters[with_type]=current`, config)
                .then((response) => {
                    this.setState({appointments: response.data});
                })
                .catch((error) => {
                    if (error.response.data.type == "Unauthorized") {
                        localStorage.removeItem("servicesData");
                        localStorage.removeItem("appointment_details");
                        localStorage.removeItem("appointment");
                        localStorage.removeItem("services");
                        localStorage.removeItem("user");
                        alert(error.response.data.type);
                        browserHistory.push(`/StepOne`)
                    } else {
                        alert(error.response.data.message);
                    }
                });

            axios.get(`${BASE_URL}/api/v1/appointments?filters[with_type]=past`, config)
                .then((response) => {
                    this.setState({pastAppointments: response.data});
                })
                .catch((error) => {
                    if (error.response.data.type == "Unauthorized") {
                        localStorage.removeItem("servicesData");
                        localStorage.removeItem("appointment_details");
                        localStorage.removeItem("appointment");
                        localStorage.removeItem("services");
                        localStorage.removeItem("user");
                        alert(error.response.data.type);
                        browserHistory.push(`/StepOne`)
                    } else {
                        alert(error.response.data.message);
                    }
                });


        }
    }

    async componentDidMount(){
        let config = {
            headers: {'Access-Token': JSON.parse(localStorage.getItem('user'))['token']}
        };

        axios.get(`${BASE_URL}/api/v1/cities`, config)
            .then((response) => {
                this.setState({
                    cities: response.data,
                    indexedCities: response.data.reduce((result, city) => {
                        return {...result, [city.name]: city};
                    }, {'': {name: ''}}),
                });
            });
    }

    /*PopupBeforeCancel*/
    showPopupBeforeCancel() {
        this.setState({
            activePopupBeforeCancel : true
        });
    }

    hidePopupBeforeCancel() {
        this.setState({
            activePopupBeforeCancel : false
        });
    }
    /*PopupBeforeCancel*/

    handleCancel(id) {

        /*close "before close" popup*/
        this.hidePopupBeforeCancel();
        /*close "before close" popup*/

        let config = {
            headers: {'Access-Token': JSON.parse(localStorage.getItem('user'))['token']}
        };
        axios.put(`${BASE_URL}/api/v1/appointments/${id}/cancel`, {id: id}, config)
            .then(() => {
                this.setState({activeAppointments: false, activeMyAppointment: false, activePopupCancel: true});
            })
            .catch((error) => {
                if (error.response.data.type == "Unauthorized") {
                    alert(error.response.data.type);
                    browserHistory.push(`/StepOne`)
                } else {
                    if (error.response.data.type == "Unauthorized") {
                        localStorage.removeItem("servicesData");
                        localStorage.removeItem("appointment_details");
                        localStorage.removeItem("appointment");
                        localStorage.removeItem("services");
                        localStorage.removeItem("user");
                        alert(error.response.data.type);
                        browserHistory.push(`/StepOne`)
                    } else {
                        alert(error.response.data.message);
                    }
                }
            });
    }

    handleSuccessfullyUpdate() {
        this.setState({activeEditAccount: false, activeSuccessfullyUpdate: true});
    }

    render() {
        return (
            <div className="smart-wrap">
                {
                    this.state.activeAppointments && 'appointments' in this.state.appointments &&
                    <UpcomingAppointment
                        appointments={this.state.appointments.appointments}
                        pastAppointments={this.state.pastAppointments.appointments}
                        handleAppointment={this.handleAppointment}
                        handleEditAccount={this.handleEditAccount}
                    />
                }
                {
                    this.state.activeMyAppointment && 'id' in this.state.appointment &&
                    <MyAppointment
                        appointment={this.state.appointment}
                        /*handleCancel={this.handleCancel}*/
                        showPopupBeforeCancel={this.showPopupBeforeCancel}
                        handleBtnBack={this.handleBtnBack}
                    />
                }
                {
                    this.state.activePopupBeforeCancel &&
                    <PopupBeforeCancel
                        appointment={this.state.appointment}
                        hidePopupBeforeCancel={this.hidePopupBeforeCancel}
                        handleCancel={this.handleCancel}
                    />
                }
                {
                    this.state.activePopupCancel &&
                    <PopupCancel/>
                }
                {
                    this.state.activeEditAccount && this.state.user &&
                    <EditAccount
                        user={this.state.user.user_data}
                        handleInputChange={this.handleInputChange}
                        handleClickEditAccount={this.handleClickEditAccount}
                        validField={this.state.validField}
                        handleBtnBack={this.handleBtnBack}
                        handlePromoCode={this.handlePromoCode}
                        cities={this.state.cities}
                    />
                }
                {
                    this.state.activeSuccessfullyUpdate &&
                    <PopupSuccessfullyUpdate/>
                }
            </div>
        )
    }
}

export default MyAccount;



/** WEBPACK FOOTER **
 ** ./src/MyAccount.js
 **/